import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    id: 1,
    title: 'Los 30 Ganchos Virales',
    value: '$19',
    image: 'https://cdn.magicpatterns.com/uploads/dXvBWpuZpF14DAb2XJMRpu/Bono1.png',
    desc: 'Las frases exactas para detener el scroll y atraer prospectos en Reels e Historias.',
    reason: 'Incluido porque sin un gancho poderoso, el contenido que creas en el Día 4 no llega a las personas correctas. El gancho es la diferencia entre 200 vistas y 20,000.'
  }, {
    id: 2,
    title: 'Plantillas de Canva para Reclutamiento',
    value: '$27',
    image: 'https://cdn.magicpatterns.com/uploads/hdHHHXk68teKBe2kVoFNs1/Bono2.png',
    desc: 'Diseños listos para publicar (Reels, Carruseles y Stories) sin perder horas diseñando.',
    reason: 'Incluido porque sin diseño profesional, el perfil que configuras en el Día 2 no transmite la autoridad que necesitas. La primera impresión visual cierra antes de que hables.'
  }, {
    id: 3,
    title: 'Guía Anti-Objeciones: El Escudo del Networker',
    value: '$25',
    image: 'https://cdn.magicpatterns.com/uploads/btnPPX2L2Tpp1ov6L8vmH2/Bono3.png',
    desc: 'Qué responder exactamente cuando te dicen: "¿Es pirámide?", "No tengo dinero" o "Tengo que consultarlo".',
    reason: 'Incluido porque sin respuestas sólidas a las objeciones, el cierre magnético del Día 7 se cae en la primera pregunta difícil del prospecto.'
  }];
  return <section className="bg-brand-dark px-6 py-20 md:py-28 border-y border-slate-800" data-id="element-20">
      <div className="mx-auto max-w-6xl" data-id="element-21">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-22">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-23">
            <div className="inline-flex items-center justify-center p-3 bg-green-500/10 rounded-full mb-4" data-id="element-24">
              <Gift className="w-8 h-8 text-green-500" data-id="element-25" />
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-26">
              Bonos de Acción Rápida:{' '}
              <span className="text-brand-gold" data-id="element-27">
                Las 3 Piezas que Completan el Sistema
              </span>
            </h2>
            <p className="text-lg md:text-xl text-slate-400 max-w-3xl mx-auto" data-id="element-28">
              Cada bono existe porque sin él, una parte del plan de 7 días{' '}
              <span className="text-white font-semibold" data-id="element-29">
                no funciona al 100%.
              </span>
            </p>
          </motion.div>
        </div>

        {/* Bonus Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-30">
          {bonuses.map((bonus, index) => <motion.div key={bonus.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15
        }} className="bg-brand-light rounded-2xl overflow-hidden border border-slate-800 flex flex-col" data-id="element-31">
              {/* Badge */}
              <div className="bg-brand-darker p-4 text-center border-b border-slate-800 flex items-center justify-center gap-2" data-id="element-32">
                <span className="text-lg" data-id="element-33">🎁</span>
                <span className="text-brand-gold font-bold uppercase tracking-wider text-sm" data-id="element-34">
                  Bono #{bonus.id}
                </span>
              </div>

              {/* Image */}
              <div className="aspect-square relative p-6 bg-gradient-to-b from-brand-light to-brand-darker flex items-center justify-center" data-id="element-35">
                <img src={bonus.image} alt={bonus.title} loading="lazy" decoding="async" width={300} height={300} className="w-full h-full object-contain drop-shadow-2xl" data-id="element-36" />
              </div>

              {/* Content */}
              <div className="p-6 flex-1 flex flex-col" data-id="element-37">
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-38">
                  {bonus.title}
                </h3>

                <p className="text-slate-300 text-sm mb-4" data-id="element-39">{bonus.desc}</p>

                {/* Reason callout */}
                <div className="bg-brand-darker/60 border border-slate-700 rounded-lg p-4 mb-6 flex-1" data-id="element-40">
                  <p className="text-slate-400 text-xs leading-relaxed italic" data-id="element-41">
                    {bonus.reason}
                  </p>
                </div>

                {/* Value */}
                <div className="mt-auto pt-4 border-t border-slate-800 flex justify-between items-center" data-id="element-42">
                  <span className="text-slate-500" data-id="element-43">
                    Valor: <span className="line-through" data-id="element-44">{bonus.value}</span>
                  </span>
                  <span className="text-green-400 font-bold" data-id="element-45">¡GRATIS HOY!</span>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Total footer */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="mt-12 text-center" data-id="element-46">
          <div className="inline-flex items-center gap-3 bg-brand-lighter/50 border border-slate-700 rounded-full px-8 py-4" data-id="element-47">
            <span className="text-slate-400 text-lg" data-id="element-48">Total en bonos:</span>
            <span className="text-white font-bold text-lg line-through opacity-60" data-id="element-49">
              $71
            </span>
            <span className="text-green-400 font-bold text-xl uppercase" data-id="element-50">
              Hoy Todo Gratis
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}